'use client';

import React, { useState } from 'react';
import { useRouter } from 'next/navigation';
import { accounuserdetails } from '../(protected)/services/login/login';
import Cookies from "js-cookie";

export default function LoginPage() {
  Cookies.remove("authToken", { path: "/" });
  Cookies.remove("AccountId", { path: "/" });
  Cookies.remove("UserInfoUserId", { path: "/" });
  const router = useRouter();

  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [agreed, setAgreed] = useState(true);

  const handleSubmit = async (e: React.FormEvent) => {
    Cookies.remove("authToken", { path: "/" });
    Cookies.remove("AccountId", { path: "/" });
    Cookies.remove("UserInfoUserId", { path: "/" });
    Cookies.remove("CompanyName", { path: "/" });
    e.preventDefault();
    setError(null);

    if (!username || !password) {
      setError("Please enter username and password.");
      return;
    }

    setLoading(true);


    const { accountlogin } = await accounuserdetails();

    const loginresult = await accountlogin(username, password);

    if (loginresult) {
      Cookies.set("authToken", loginresult.token, {
        expires: 1 / 48, // 20 minutes
        path: "/",        // important
        secure: true      // required for HTTPS
      });
      Cookies.set("AccountId", loginresult.accountId.toString(), {
        expires: 1 / 48,
        path: "/",
        secure: true
      });
      Cookies.set("UserInfoUserId", loginresult.userId.toString(), { expires: 1 / 48 });
      Cookies.set("UserName", loginresult.userName.toString(), { expires: 1 / 48 });
      Cookies.set("AccountName", loginresult.accountName.toString(), { expires: 1 / 48 });
      Cookies.set("CompanyName", loginresult.companyName.toString(), { expires: 1 / 48 });
      const createdDate = new Date(loginresult.createddate);

      Cookies.set("cdate", createdDate.toISOString(), { expires: 1 / 48 });
      Cookies.set("ismail", loginresult.ismail.toString(), { expires: 1 / 48 });
      Cookies.set("iswhatsapp", loginresult.iswhatsapp.toString(), { expires: 1 / 48 });
      Cookies.set("issms", loginresult.issms.toString(), { expires: 1 / 48 });
      Cookies.set("isactive", loginresult.activestatus.toString(), { expires: 1 / 48 });
      router.push("/customers"); // ⬅ Correct redirect
      return;
    }

    setLoading(false);
  };

  return (
    <main className="w-full max-w-md p-6">
      {/* User Manual Download Button */}
      {/* <a
        href="/Dear Customer Manual.pdf"
        download
        className="absolute right-4 top-4 flex items-center gap-2 rounded-md bg-orange-500 px-4 py-2 text-sm font-medium text-white shadow hover:bg-orange-600 transition"
      >
        📄 User Manual
      </a> */}
      <div className="bg-white shadow-md rounded-lg px-8 py-10">
        <div className="flex flex-col items-center mb-6">
          <div className="mb-4">
            <img
              src="/logo.svg"
              alt="Dear Customer Logo"
              width={165}
              height={100}
              className="object-contain"
            />
          </div>
        </div>

        <form onSubmit={handleSubmit} className="space-y-4" aria-label="Login form">
          <div className="mb-4">
            <label
              htmlFor="username"
              className="block mb-1 text-sm text-gray-600"
            >
              Username
            </label>

            <input
              type="text"
              id="username"
              name="username"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              placeholder="Enter username"
              className="w-full px-4 py-3 border border-gray-300 rounded outline-none focus:border-orange-500"
            />
          </div>
          <div className="mb-5">
            <label
              htmlFor="password"
              className="block mb-1 text-sm text-gray-600"
            >
              Password
            </label>

            <input
              type="password"
              id="password"
              name="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="Enter password"
              className="w-full px-4 py-3 border border-gray-300 rounded outline-none focus:border-orange-500"
            />
          </div>
          <div className="flex items-start mb-3">
            <input
              id="agree"
              type="checkbox"
              checked={agreed}
              onChange={(e) => setAgreed(e.target.checked)}
              className="h-4 w-4 mt-0.5 accent-orange-500 border-gray-300 rounded cursor-pointer"
            />
            <label htmlFor="agree" className="ml-2 text-xs text-gray-900">
              I agreed to{' '}
              <a className="underline text-gray-600">Terms of services</a> and{' '}
              <a className="underline text-gray-600">Privacy Policy</a>
            </label>
          </div>
          {error && <p className="text-sm text-red-600">{error}</p>}

          <div className="flex items-center justify-between">
            <button
              type="submit"
              disabled={loading || !agreed}
              className={`
                    w-full h-[46px] text-xl uppercase rounded-md flex items-center justify-center
                    transition-all duration-200 tracking-wide my-1
                    ${loading || !agreed
                  ? 'bg-orange-300 cursor-not-allowed'
                  : 'bg-gradient-to-br from-orange-500 to-orange-600 hover:from-orange-600 hover:to-orange-700 hover:scale-105 cursor-pointer'
                }
                    text-white focus:outline-none focus:ring-2 focus:ring-orange-500 focus:ring-offset-2
                  `}
            >
              {loading ? 'Logging in...' : 'Login'}
            </button>
          </div>

          {/* <div className="flex items-start mb-3">
            <input
              id="agree"
              type="checkbox"
              checked={agreed}
              onChange={(e) => setAgreed(e.target.checked)}
              className="h-4 w-4 mt-0.5 accent-orange-500 border-gray-300 rounded cursor-pointer"
            />
            <label htmlFor="agree" className="ml-2 text-xs text-gray-900">
              I agreed to{' '}
              <a className="underline text-gray-600">Terms of services</a> and{' '}
              <a className="underline text-gray-600">Privacy Policy</a>
            </label>
          </div> */}

          <div className="pt-2 flex items-center justify-between">
            <div className="text-sm">
              <a href="/forgotpassword" className="font-medium text-gray-600 hover:text-orange-500">
                Forgot Password?
              </a>
            </div>
            <div className="text-sm">
              <a href="/createuser" className="font-medium text-gray-600 hover:text-orange-500">
                Create New User
              </a>
            </div>
            {/*<div className="text-center">
              <a
                href="#"
                onClick={(e) => {
                  e.preventDefault();
                  // SSO login link - replace href with real SSO endpoint
                  window.location.href = '/api/auth/sso';
                }}
                className="text-sm font-medium text-gray-600 hover:text-orange-500"
              >
                Login using SSO
              </a>
            </div>*/}
          </div>
        </form>
      </div>
    </main>
  );
}
